import { useEffect } from 'react';

export const useSaveControls = (onSave: () => void | Promise<void>) => {
	useEffect(() => {
		document.onkeydown = async (event: KeyboardEvent) => {
			if ((event.metaKey || event.ctrlKey) && event.key === 's') {
				event.preventDefault();
				await onSave();
			}
		};

		return () => {
			document.onkeydown = () => null;
		};
	}, [onSave]);
};
